// 注文状況照会APIの契約。
//
// 現行は wuStorefront 自身の /api/order-status。
// 語彙は ES さんの Worker から引き取ったときの返却JSONに由来する（キー名・state・日付の形）。
// name だけは返さない（氏名を出す必要が無いため。ウィジェット側は空なら出さない）。

/**
 * 照会は Guid 経由のみ（2026-08-20 にフォーム経路を廃止）。
 * このページのURLを知る手段が Guid 付きメールしかないため、これで導線は足りる。
 */
export type StatusRequest = { g: string }

export interface TrackingNumber {
  no: string
  url: string
  /** true なら番号をクリップボードにコピーしてから追跡ページを開く。false は素のリンク。 */
  copy?: boolean
}

export interface Step {
  /** "shipped" のステップにだけ追跡ボックスを差し込む。 */
  key?: string
  label: string
  state: 'done' | 'current' | 'upcoming'
  /** "2026/08/17" 形式。表示側で M/D に整形する（- 区切りも受ける）。 */
  date?: string
  desc?: string
  eta?: string
}

export interface StatusResponse {
  /** false または欠落で「見つかりませんでした」表示。エラーコードは持っていない。 */
  ok: boolean
  order_no: string
  order_date?: string
  name?: string
  payment?: string
  cancelled?: boolean
  /**
   * オフセット付きの ISO。実データは "+09:00" 付き（"Z" でも表示結果は同じ）。
   * 表示側は Date にしてから +9h し UTC 系ゲッタで読む＝JST。
   * オフセットを付け忘れるとブラウザのローカル時刻として解釈され、環境によって時刻がずれる。
   */
  last_updated?: string
  steps?: Step[]
  /** 発送前は null で返ってくる（未定義ではなく null）。 */
  tracking?: { carrier_name: string; numbers: TrackingNumber[] } | null

  // 以下は Worker が返しているが page/2511 は使っていない。契約の記録として残す。
  stage?: string
  stage_label?: string
  updated?: boolean
}

export async function fetchStatus(api: string, payload: StatusRequest): Promise<StatusResponse | null> {
  const r = await fetch(api, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    cache: 'no-store',
    body: JSON.stringify(payload),
  })

  // 200（見つかった）と 404（受注が無い・入力不正）だけが「答えが返ってきた」状態。
  // それ以外の非2xx——DB障害の 500 など——で本文を読むと、同じ {ok:false} なので
  // 「ご注文が見つかりませんでした」と表示されてしまう。
  // 注文は存在するのに「無い」と言われた客は、問い合わせるか再注文する。実害がある方の誤りなので、
  // ここで投げて呼び出し側の catch（＝通信エラーの案内）に落とす。
  if (!r.ok && r.status !== 404) throw new Error(`status ${r.status}`)

  return (await r.json()) as StatusResponse | null
}
